import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageView } from '../analytics';

// Marketing-only: staff and teacher portal activity must not pollute marketing
// analytics. Exact /teach and /careers remain public marketing pages.
export function isPortalPath(pathname) {
  return (
    pathname.startsWith('/staff') ||
    pathname.startsWith('/teach/login') ||
    pathname.startsWith('/teach/portal')
  );
}

export default function AnalyticsGate() {
  const { pathname, search } = useLocation();
  const portal = isPortalPath(pathname);

  useEffect(() => {
    if (portal) return;
    initAnalytics();
    trackPageView({
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, portal, search]);

  return null;
}
